<template lang="html">
  <div class="flex-table-title">
    <div>
      <strong
        class="flex-table-title__text"
        :class="titleColor"
      >
        {{ title }}
      </strong>
      <span
        v-if="subName"
        class="align-middle"
      >
        - {{ subName }}
      </span>
      <template v-if="executed">
        <i
          aria-hidden="true"
          class="fas"
          :class="titleIcon"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasAlarms: {
      type: Boolean,
    },
    executed: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    subName: {
      type: String,
    },
  },
  computed: {
    altDescription() {
      return this.hasAlarms ? 'A bell icon' : 'A check icon';
    },
    titleIcon() {
      return this.hasAlarms ? 'fa-exclamation-triangle text-red flex-table-title__alarm-icon ml-2' : 'fa-check flex-table-title__alarm-icon text-green ml-2';
    },
    titleColor() {
      return this.hasAlarms ? 'text-red' : 'text-green';
    },
  },
};
</script>

<style lang="sass">
  @import "src/styles/defaults/variables"

  .flex-table-title
    &__alarm-icon
      font-size: 1.2em
    &__text
      vertical-align: middle
    &__icon
      margin-left: 5px
      width: 18px
      height: 18px
</style>
